import { render, staticRenderFns } from "./SortableColHeader.vue?vue&type=template&id=4f5dc342&scoped=true&"
import script from "./SortableColHeader.vue?vue&type=script&lang=js&"
export * from "./SortableColHeader.vue?vue&type=script&lang=js&"
import style0 from "./SortableColHeader.vue?vue&type=style&index=0&id=4f5dc342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dc342",
  null
  
)

export default component.exports